import { supabase } from './supabase';


const STRIPE_CHECKOUT_URL = 'https://nepfzpzxogylvwtvhgep.functions.supabase.co/create-checkout';

export const createCheckoutSession = async ({
  priceId,
  type, // 'credits' or 'subscription'
  quantity = 1,
  successUrl = window.location.origin + '/payment-success',
  cancelUrl = window.location.origin + '/payment-cancelled',
}) => {
  try {
    // Get the user's session to pass the token
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) {
      throw new Error('No active session found');
    }

    const response = await fetch(STRIPE_CHECKOUT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`,
      },
      body: JSON.stringify({
        priceId,
        type,
        quantity,
        successUrl,
        cancelUrl,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to create checkout session');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error creating checkout session:', error);
    throw error;
  }
};